import { useEffect } from 'react';

const APP_NAME = 'PulseCheck';

// Module-level so the route title and the down-count can be set independently
// and still render one coherent string.
let routeTitle = '';
let downCount = 0;

const NORMAL_ICON = '/favicon.svg';
const ALERT_ICON = '/favicon-alert.svg';

function render() {
  const prefix = downCount > 0 ? `(${downCount}) ` : '';
  document.title = routeTitle ? `${prefix}${routeTitle} · ${APP_NAME}` : `${prefix}${APP_NAME}`;

  const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (link) {
    const wanted = downCount > 0 ? ALERT_ICON : NORMAL_ICON;
    // Only touch the DOM when it actually changes, or Chrome re-fetches it.
    if (!link.href.endsWith(wanted)) link.href = wanted;
  }

  const themeColor = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]:not([media])');
  if (themeColor) themeColor.content = downCount > 0 ? '#D14437' : '#0B6FA4';
}

/** Name the current page. The tab and browser history become useful. */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    routeTitle = title;
    render();
    return () => { routeTitle = ''; };
  }, [title]);
}

/**
 * Carry the number of failing services in the tab title and favicon.
 *
 * This is the whole point of a monitoring tool being a browser tab: it can
 * tell you something is wrong while you are looking at a different window.
 */
export function useDownCountTitle(count: number) {
  useEffect(() => {
    downCount = count;
    render();
    return () => { downCount = 0; render(); };
  }, [count]);
}
